import React from 'react';

import styles from './Card.module.css';
import { CardProps } from './Card.types';

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  style,
  onMouseEnter,
  onMouseLeave,
}) => {
  const classNames = `${styles.card} ${onClick ? styles.interactive : ''} ${className}`.trim();

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={classNames}
      onClick={onClick}
      style={style}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? handleKeyDown : undefined}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};
